module.exports = __webpack_public_path__ + "static/media/upute-lexhr.3db54a2c.pdf";